<script setup lang="ts">
import { computed } from 'vue';
import { Plus, X } from '@lucide/vue';
import { appendTextLink, textLinks, unlinkTextLink, updateTextLink } from '../richTextEditing';
// Список ссылок галочки согласия. Ссылки хранятся прямо в тексте как [текст](адрес), поэтому их может быть сколько угодно.
const props = defineProps<{ text: string }>();
const emit = defineEmits<{ 'update:text': [value: string] }>();
const links = computed(() => textLinks(props.text));
const setLabel = (index: number, label: string) => emit('update:text', updateTextLink(props.text, index, label, links.value[index].url));
const setUrl = (index: number, url: string) => { if (/^(https?:\/\/|mailto:)\S+$/i.test(url.trim())) emit('update:text', updateTextLink(props.text, index, links.value[index].label, url)); };
const add = () => emit('update:text', appendTextLink(props.text, links.value.length ? 'Документ' : 'Политика обработки персональных данных', 'https://bgpu.ru/'));
</script>
<template>
  <div class="consent-links">
    <span class="input-label">Ссылки в тексте галочки</span>
    <div v-for="(link, index) in links" :key="index" class="consent-link-row">
      <input class="control" :value="link.label" aria-label="Текст ссылки" placeholder="Текст ссылки" @change="setLabel(index, ($event.target as HTMLInputElement).value)"/>
      <input class="control" type="url" :value="link.url" aria-label="Адрес ссылки" placeholder="https://…" @change="setUrl(index, ($event.target as HTMLInputElement).value)"/>
      <button type="button" class="tool-btn danger" title="Убрать ссылку (слова останутся в тексте)" aria-label="Убрать ссылку" @click="emit('update:text', unlinkTextLink(text, index))"><X :size="15"/></button>
    </div>
    <button type="button" class="merge-consent" @click="add"><Plus :size="15"/>Добавить ссылку</button>
    <p class="field-help">Ссылок может быть несколько. Можно также выделить слова в тексте и нажать «Ссылка».</p>
  </div>
</template>
